export default {
  name: 'image',
  type: 'button',
  icon: 'ios-image',
  description: '图片',
  handleToolbar: (quill) => {
    // quill.format('image')
  }
}



// WEBPACK FOOTER //
// ./src/components/quill/toolbar/image.js